import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouteTemplateScreenHandler } from 'src/app/handlers/RouteTemplateScreenHandler';
import screen from '../../../../assets/RouteTemplateScreen.json'

@Component({
  selector: 'app-route-template-detail',
  templateUrl: './route-template-detail.component.html',
  styleUrls: ['./route-template-detail.component.scss']
})
export class RouteTemplateDetailComponent implements OnInit {

  public eventFilter: any;

  public screenStructure = JSON.parse(JSON.stringify(screen))
  @Input() uid: string;

  constructor(private route:ActivatedRoute, public screenHandler: RouteTemplateScreenHandler) { }

  ngOnInit() {
    this.uid = this.route.snapshot.paramMap.get('id');

    this.eventFilter = {container: Number.parseInt(this.uid)};
  }

}
